import { Provider } from "react-redux";
import Carts from "./components/Carts";
import Products from "./components/Products";
import store from "./redux/store";

function App() {
    return (
        <Provider store={store}>
            <div className="bg-gray-50 h-screen">
                <h1 className="text-gray-900 text-center text-3xl font-bold py-10 capitalize underline decoration-purple-500 decoration-4 underline-offset-8">
                    shopping cart
                </h1>
                <div className="grid grid-cols-12 gap-6">
                    <Products />
                    <Carts />
                </div>
            </div>
        </Provider>
    );
}

export default App;
